module.exports = __webpack_public_path__ + "static/media/shape0_3.7d58409f.obj";